import { useEffect } from "react";

const JsonLd = ({ data, id = "page-jsonld" }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      document.getElementById(id)?.remove();
    };
  }, [data, id]);

  return null;
};

export default JsonLd;
